export const ComponentAction = {
  setNavigation: "setNavigation",
  setNavigationUpdate: "setNavigationUpdate",
  setAppMode: "setAppMode",
  setIsEnableKtznLang: "setIsEnableKtznLang",
  setBottomNavigation: "setBottomNavigation",
  setIsWeChat: "setIsWeChat",
  setIsLoading: "setIsLoading",
  setIsSaving: "setIsSaving",
  setInitialLoading: "setInitialLoading",
  closePrivacyPolicyFooter: "closePrivacyPolicyFooter",
  setReConnectingNow: "setReConnectingNow",
  setSession: "setSession",
  createSession: "createSession",
  setSessionTimeout: "setSessionTimeout",
  setCheckNotificationPermission: "setCheckNotificationPermission",
  guestHideHomeIcon: "guestHideHomeIcon",
};

export const ComponentMutation = {
  SET_NAVIGATION: "NAVIGATION",
  SET_NAVIGATION_UPDATE: "NAVIGATION_UPDATE",
  SET_APP_MODE: "APP_MODE",
  SET_IS_ENABLE_KTZN_LANG: "SET_ENABLE_KTZN_LANG",
  SET_BOTTOM_NAVIGATION: "BOTTOM_NAVIGATION",
  SET_IS_WECHAT: "SET_IS_WECHAT",
  SET_IS_LOADING: "IS_LOADING",
  SET_IS_SAVING: "IS_SAVING",
  SET_INITIAL_LOADING: "INITIAL_LOADING",
  SET_CLOSE_PRIVACY_POLICY_FOOTER: "CLOSE_PRIVACY_POLICY_FOOTER",
  SET_IS_RE_CONNECTINT_NOW: "SET_IS_RE_CONNECTINT_NOW",
  SET_SESSION: "SET_SESSION",
  ADD_EVENT_ID: "ADD_EVENT_ID",
  SET_IS_FROM_LOGIN: "SET_IS_FROM_LOGIN",
  SET_IS_REDIRECTED: "SET_IS_REDIRECTED",
  SET_CHECK_NOTIFICATION_PERMISSION: "CHECK_NOTIFICATION_PERMISSION",
  GUEST_HIDE_HOME_ICON: "GUEST_HIDE_HOME_ICON",
};
